import PropTypes from "prop-types"
import styled from "styled-components"
import { Box } from "@fastly/consistently"

// Grid Child is a wrapper to place a component w/in a grid

const GridChild = styled(Box)`
  ${(props) =>
    ["sm", "md", "lg", "xl"].map(
      (breakpoint) =>
        props[breakpoint] &&
        `@media (min-width: ${props.theme.breakpoints[breakpoint]}) {
        grid-column: ${props[breakpoint]};
      }`
    )}
`

GridChild.propTypes = {
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
  xl: PropTypes.string,
}

export default GridChild
